import React from "react";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar, LineChart, Line, Legend } from "recharts";

const tooltipStyle = { background: "#0a1128", border: "1px solid rgba(255,255,255,0.14)", borderRadius: 8, fontSize: 12, color: "#e5e7eb" };
const axisStyle = { fill: "#a5acb8", fontSize: 11 };

export function KccAreaChart({ data, dataKey = "value", label = "Value", color = "#b87333", height = 260, xKey = "date" }) {
    return (
        <ResponsiveContainer width="100%" height={height}>
            <AreaChart data={data} margin={{ top: 10, right: 12, left: 0, bottom: 0 }}>
                <defs>
                    <linearGradient id={`grad-${dataKey}`} x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor={color} stopOpacity={0.55} />
                        <stop offset="95%" stopColor={color} stopOpacity={0.02} />
                    </linearGradient>
                </defs>
                <CartesianGrid stroke="rgba(255,255,255,0.05)" strokeDasharray="3 3" />
                <XAxis dataKey={xKey} tick={axisStyle} stroke="rgba(255,255,255,0.15)" />
                <YAxis tick={axisStyle} stroke="rgba(255,255,255,0.15)" />
                <Tooltip contentStyle={tooltipStyle} labelStyle={{ color: "#a5acb8" }} />
                <Area type="monotone" dataKey={dataKey} name={label} stroke={color} fill={`url(#grad-${dataKey})`} strokeWidth={2} />
            </AreaChart>
        </ResponsiveContainer>
    );
}

export function KccLineChart({ data, series = [], height = 260, xKey = "date" }) {
    return (
        <ResponsiveContainer width="100%" height={height}>
            <LineChart data={data} margin={{ top: 10, right: 12, left: 0, bottom: 0 }}>
                <CartesianGrid stroke="rgba(255,255,255,0.05)" strokeDasharray="3 3" />
                <XAxis dataKey={xKey} tick={axisStyle} stroke="rgba(255,255,255,0.15)" />
                <YAxis tick={axisStyle} stroke="rgba(255,255,255,0.15)" />
                <Tooltip contentStyle={tooltipStyle} labelStyle={{ color: "#a5acb8" }} />
                <Legend wrapperStyle={{ fontSize: 11, color: "#a5acb8" }} />
                {series.map((s) => (
                    <Line key={s.key} type="monotone" dataKey={s.key} name={s.label} stroke={s.color} strokeWidth={2} dot={false} />
                ))}
            </LineChart>
        </ResponsiveContainer>
    );
}

export function KccBarChart({ data, dataKey = "value", label = "Value", color = "#2d68c4", height = 260, xKey = "name" }) {
    return (
        <ResponsiveContainer width="100%" height={height}>
            <BarChart data={data} margin={{ top: 10, right: 12, left: 0, bottom: 0 }}>
                <CartesianGrid stroke="rgba(255,255,255,0.05)" strokeDasharray="3 3" />
                <XAxis dataKey={xKey} tick={axisStyle} stroke="rgba(255,255,255,0.15)" />
                <YAxis tick={axisStyle} stroke="rgba(255,255,255,0.15)" />
                <Tooltip contentStyle={tooltipStyle} labelStyle={{ color: "#a5acb8" }} />
                <Bar dataKey={dataKey} name={label} fill={color} radius={[4, 4, 0, 0]} />
            </BarChart>
        </ResponsiveContainer>
    );
}
